import { Box, BoxProps } from "@chakra-ui/react";

export interface DrawerBodyProps extends BoxProps {}

export const DrawerBody = (props: DrawerBodyProps) => {
  return <Box py={4} {...props} />;
};
